import React from 'react';
import MenuList from '@wix/da-ds/pkg/Dropdown/MenuList';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { getVerificationEmailAddress } from '../../../../../../publicSession/selectors';
import UserLink from '../../../../../../User/Link/UserLinkWithTooltip';
import VerificationReminder from '../../../../VerificationReminder';
import { useCurrentUser } from '../../../../../../utils/hooks/useCurrentUser';
import { useContentFilterItem, useLogoutItem, useSubscriptionsItem, useSaleBannerItem, useBuyCoreItem, useStudioItem, useThemeSwitcherItem, useAISuppressionItem, useHelpItem, useSettingsItem, usePointsBalanceItem, useCustomerDashboardItem, useEarningsItem, useBillingItem, useFragmentsBalanceItem, usePushSubscriptionItem } from '../../../items';
import userMenuStyles from '../../UserMenuDesktop.scss';
import SiteHeaderStyles from '../../../../../SiteHeaderDesktop/SiteHeaderDesktop.scss';
const LoggedInMenu = ({ disableThemeSwitcher, className })=>{
    const { t } = useTranslation();
    const verificationEmail = useSelector(getVerificationEmailAddress);
    const currentUser = useCurrentUser();
    const buyCoreItem = useBuyCoreItem();
    const saleBannerItem = useSaleBannerItem();
    const subscriptionsItem = useSubscriptionsItem();
    const logoutItem = useLogoutItem();
    const contentFilterItem = useContentFilterItem();
    const studioItem = useStudioItem();
    const themeSwitcherItem = useThemeSwitcherItem();
    const helpItem = useHelpItem();
    const aiSuppressionItem = useAISuppressionItem();
    const settingsItem = useSettingsItem();
    const fragmentsBalanceItem = useFragmentsBalanceItem();
    const pointsBalanceItem = usePointsBalanceItem();
    const customerDashboardItem = useCustomerDashboardItem();
    const earningsItem = useEarningsItem();
    const billingItem = useBillingItem();
    const pushSubscriptionItem = usePushSubscriptionItem();
    const loggedInUser = currentUser;
    return /*#__PURE__*/ React.createElement(MenuList, {
        id: "site-header-user-menu",
        className: classnames(className, userMenuStyles['user-menu'], SiteHeaderStyles['icon-submenu']),
        renderOnSSR: true,
        itemsFillContainerWidth: true,
        items: [
            {
                items: [
                    {
                        label: /*#__PURE__*/ React.createElement(Flex, {
                            alignItems: "baseline",
                            justifyContent: "space-between",
                            className: userMenuStyles['user-profile-line']
                        }, /*#__PURE__*/ React.createElement(UserLink, {
                            className: userMenuStyles['user-link'],
                            symbolClassName: userMenuStyles['user-link-symbol'],
                            user: loggedInUser,
                            withTooltip: false,
                            biData: {
                                sectionname: 'menu'
                            }
                        }))
                    },
                    buyCoreItem,
                    saleBannerItem,
                    subscriptionsItem,
                    studioItem
                ]
            },
            !!verificationEmail && {
                items: [
                    {
                        label: /*#__PURE__*/ React.createElement(VerificationReminder, {
                            email: verificationEmail
                        }),
                        className: userMenuStyles['verification-item']
                    }
                ],
                className: userMenuStyles['verification-group']
            },
            !verificationEmail && {
                items: [
                    {
                        label: t('siteHeader.userMenu.myStash'),
                        link: Url.buildFromPath(URLS.STASH),
                        biData: BiData({
                            evid: 702,
                            link_url: Url.buildFromPath(URLS.STASH),
                            menu_item: 'stash',
                            menu_name: 'profile'
                        })
                    },
                    {
                        label: t('siteHeader.userMenu.dreamup'),
                        link: Url.dreamupLink(),
                        biData: BiData({
                            evid: 702,
                            link_url: Url.dreamupLink(),
                            menu_item: 'dreamup',
                            menu_name: 'profile'
                        })
                    }
                ]
            },
            !verificationEmail && {
                items: [
                    pointsBalanceItem,
                    fragmentsBalanceItem,
                    earningsItem,
                    billingItem,
                    customerDashboardItem
                ]
            },
            {
                items: [
                    !!verificationEmail && billingItem,
                    !disableThemeSwitcher && themeSwitcherItem,
                    settingsItem,
                    contentFilterItem,
                    aiSuppressionItem,
                    pushSubscriptionItem
                ],
                className: verificationEmail && userMenuStyles['post-verification-group']
            },
            {
                items: [
                    helpItem,
                    logoutItem
                ]
            }
        ]
    });
};
LoggedInMenu.displayName = 'LoggedInMenu';
export default LoggedInMenu;

//# sourceMappingURL=LoggedInMenu.js.map